import { Tooltip, TooltipProps } from '@sternum/ui';
import { ThemeMode, ThemeProvider } from '@sternum/web/components/theme/main';

export interface MenuTooltipProps extends TooltipProps {
  themeMode?: ThemeMode;
}

export function MenuTooltip({ themeMode, ...props }: MenuTooltipProps) {
  return (
    <ThemeProvider mode={themeMode}>
      <Tooltip {...props} />
    </ThemeProvider>
  );
}
